import React, { useCallback, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from "./constants/firebase";
import { db } from "./constants/firebase";
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Grow from '@material-ui/core/Grow';




const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
  start: props => ({
    background: props.palette.gradient.default
  }),
}));

export default function BasicInformation(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const team = props.props ? props.props.data.team : "";
  const university = props.props ? props.props.data.university : "";
  const name = props.props ? props.props.data.name : "";
  const email = props.props ? props.props.data.email : "";
  const phone = props.props ? props.props.data.phone : "";
  const street = props.props ? props.props.data.street : "";
  const city = props.props ? props.props.data.city : "";
  const state = props.props ? props.props.data.state : "";
  const zip = props.props ? props.props.data.zip : "";
  const goNext = props.props ? props.props.function: "";
  const [show, setShow] = useState(true);
  
  console.log(props);
  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const { team, university, name, email, phone, street, city, state, zip } = event.target.elements;
      try {

        var user = firebase.auth().currentUser;

        const dateObj = new Date();
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const date = dateObj.toLocaleDateString(undefined, options)
        const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        db.collection("users").doc(user.email).update({
          BasicInformation: {
            data: {
              team: team.value,
              university: university ? university.value : "",
              name: name.value,
              email: email.value,
              phone: phone.value, 
              street: street.value, 
              city: city.value,
              state: state.value,
              zip: zip.value
            },
            completed: true
          },
          LastUpdated: (date + " " + time)
        });

        goNext();
        // history.push("/tasks");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  return (
    <ThemeProvider theme={currentTheme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Grow in={!show}>
        <div className={classes.paper}>
            <Button
           onClick={() => setShow(true)}
           className={classes.start}
          >
            Start Application
            </Button>
        </div>
        </Grow>
        <Grow in={show}>
        <div className={classes.paper}>
          <Typography component="h1" variant="h3">
              Basic Information
          </Typography>
          <Box marginBottom={2}>
          <Divider variant="middle" />
          </Box>
          <Typography component="h1" variant="body1">
          Be sure to accurately list the information. Also, it is required that you submit a captain’s email or team email that can be used as the primary method of communication with your team.

          </Typography>
            <form className={classes.form} onSubmit={handleSignUp}>
            <Typography component="h1" variant="h5">
              Team Information
          </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="team"
                label="Team Name"
                name="team"
                defaultValue={team}
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="University Representing"
                label="University Representing"
                id="university"
                defaultValue={university}
              />
              <Typography component="h1" variant="h5">
              Team Captain's Contact Info
          </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="name"
                label="Name"
                name="name"
                autoFocus
                defaultValue={name}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="email"
                label="Email"
                id="email"
                defaultValue={email}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="phone"
                label="Primary Phone"
                id="phone"
                defaultValue={phone}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="street"
                label="Street Address"
                id="street"
                defaultValue={street}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="city"
                label="City"
                id="city"
                defaultValue={city}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="state"
                label="State"
                id="state"
                defaultValue={state}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="zip"
                label="ZIP Code"
                id="zip"
                defaultValue={zip}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                className={classes.submit}
              >
                Submit
            </Button>
            </form> 
        </div>
        </Grow>
      </Container>
    </ThemeProvider>
  );
}